import { Address as AddressType } from '@karehero/models';
import Box from '@mui/material/Box';

interface AddressProps {
  address: AddressType;
}

export const Address = ({ address }: AddressProps) => (
  <Box sx={{ m: 0, typography: 'bodyMd' }}>
    {[
      address.streetAddress1,
      address.streetAddress2,
      address.streetAddress3,
      address.streetAddress4,
      address.city,
      address.county,
      address.district,
      address.region,
      address.country,
      address.postcode,
    ]
      .filter(Boolean)
      .join(', ')}
  </Box>
);

export default Address;
